import type { ErrorStep } from '../diagnostics';

export type RulesOutcome<T> = { ok: true; value: T } | { ok: false };

/**
 * Runs the rules step. A crash is noted for the diagnostic report (step 'rules', type only) and
 * returned as `{ ok: false }`, so the app can say "something went wrong" and offer the report.
 */
export function runRulesStep<T>(run: () => T, noteError: (step: ErrorStep, err: unknown) => void): RulesOutcome<T> {
  try {
    return { ok: true, value: run() };
  } catch (err) {
    noteError('rules', err);
    return { ok: false };
  }
}
